/* eslint-disable */

import {
  HiX,
} from "react-icons/hi";

import Links from "./components/Links";

import SidebarCard from "components/sidebar/componentsrtl/SidebarCard";

import routes from "routes.js";


const Sidebar = ({
  open,
  onClose,
}) => {

  return (

    <div
      className={`
        fixed
        left-0
        top-0
        z-50

        flex
        h-screen
        w-[260px]
        flex-col

        bg-white
        shadow-2xl
        shadow-black/10

        transition-transform
        duration-300
        ease-in-out

        dark:bg-navy-800
        dark:text-white

        xl:translate-x-0

        ${
          open
            ? "translate-x-0"
            : "-translate-x-full"
        }
      `}
    >

      {/* =====================================================
          MOBILE CLOSE BUTTON
      ===================================================== */}

      <button
        type="button"
        onClick={onClose}
        className="
          absolute
          right-4
          top-4
          z-10

          flex
          h-9
          w-9
          items-center
          justify-center

          rounded-lg

          text-gray-500

          transition
          hover:bg-gray-100
          hover:text-gray-700

          dark:hover:bg-white/10
          dark:hover:text-white

          xl:hidden
        "
        aria-label="Close sidebar"
      >
        <HiX
          size={20}
        />
      </button>


      {/* =====================================================
          BRAND / LOGO
      ===================================================== */}

      <div
        className="
          flex
          h-[115px]
          flex-shrink-0
          items-center

          border-b
          border-gray-200

          px-8

          dark:border-white/10
        "
      >

        <div>

          <div
            className="
              font-poppins
              text-[24px]
              font-extrabold
              uppercase
              tracking-tight

              text-navy-700

              dark:text-white
            "
          >
            ADMIN PANEL
          </div>


          <div
            className="
              mt-1

              text-[10px]
              font-semibold
              uppercase
              tracking-[0.22em]

              text-blue-500

              dark:text-blue-300
            "
          >
            Sales CRM
          </div>

        </div>

      </div>


      {/* =====================================================
          SCROLLABLE NAVIGATION
      ===================================================== */}

      <div
        className="
          sidebar-scroll

          min-h-0
          flex-1

          overflow-y-auto
          overflow-x-hidden

          px-4
          py-5
        "
      >

        <ul
          className="
            flex
            flex-col
            gap-1
          "
        >

          <Links
            routes={routes}
          />

        </ul>

      </div>


      {/* =====================================================
          BOTTOM SIDEBAR CARD
      ===================================================== */}

      <div
        className="
          flex-shrink-0

          border-t
          border-gray-200

          bg-white

          px-4
          py-4

          dark:border-white/10
          dark:bg-navy-800
        "
      >

        <SidebarCard />

      </div>

    </div>
  );
};


export default Sidebar;